import { useWindowWidth } from '@ally/use-window-width';
export const useBoundaries = ({ inputWrapperRef, }) => {
    // we don't need the return value here
    // we just want the component to re-render when the window width updates
    useWindowWidth();
    const inputWrapperEl = inputWrapperRef.current;
    const rect = inputWrapperEl === null || inputWrapperEl === void 0 ? void 0 : inputWrapperEl.getBoundingClientRect();
    const boundaries = {
        top: (rect === null || rect === void 0 ? void 0 : rect.height) || 0,
        left: 0,
        width: (rect === null || rect === void 0 ? void 0 : rect.width) || 0,
    };
    return { boundaries };
};
//# sourceMappingURL=useBoundaries.js.map